<template>
    <div>
        <div class="bg-gray2">
            <div class="container-fluid">
                <!--/* Reco Mobile Mobile + Tablette */-->
                <div class="row swiper-1row d-xl-none py-1 py-md-2 mt-2">
                    <div class="col-12">
                        <h2 class="no-signature " v-html="title" />
                        <div class="mb-0 mb-md-2 ob1-carrousel swiper-container reco-mobiles-swiper-container">
                            <div class="swiper-wrapper">
                                <div
                                    v-for="(mobile, index) in mobiles"
                                    :key="'reco' + mobile.seoId.value"
                                    class="swiper-slide"
                                >
                                    <reco-mobile
                                        :mobile="mobile"
                                        :index="index+1"
                                        :data-pdb-zid="dataPdbZid"
                                        :advantage-messages="advantageMessages"
                                        :funding-details-dto="fundingDetailsDto"
                                        @fundingDetailsClick="handleFundingDetailsClick"
                                    />
                                </div>
                            </div>
                            <button id="swiper-button-prev" class="d-block swiper-button-prev" title="Précédent">
                                <span class="visually-hidden">Précédent</span>
                            </button>
                            <button id="slide-next-button" class="d-block swiper-button-next" title="Suivant">
                                <span class="visually-hidden">Suivant</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!--/* Reco Mobile Desktop */-->
                <div class="d-none d-xl-block py-2 mt-2 grid-4col">
                    <h2 class="no-signature " v-html="title" />
                    <div v-for="y in numberOfRows(4)" :key="'reco' + y" class="row">
                        <div v-for="x in 4" :key="'reco' + x" class="col-3">
                            <reco-mobile
                                v-if="mobileAt(x, y, 4)"
                                :mobile="mobileAt(x, y, 4)"
                                :index="x"
                                :data-pdb-zid="dataPdbZid"
                                :advantage-messages="advantageMessages"
                                :funding-details-dto="fundingDetailsDto"
                                @fundingDetailsClick="handleFundingDetailsClick"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!--/* Lien voir tous les mobiles propre à la N-1 */-->
            <div v-if="linkUrl && linkLabel" class="d-flex justify-content-center pb-1 mb-3">
                <ob1-liens
                    :text="linkLabel"
                    :href="linkUrl"
                    with-arrow
                    data-oevent-category="marchand_eqpt"
                    data-oevent-action="voir-tous-les-mobiles"
                    :data-oevent-label="linkUrl"
                />
            </div>
        </div>

        <div v-if="subTitle" class="container-fluid mt-1 mt-md-3 d-webview-none">
            <template v-if="shop === 'ORANGE'">
                <h2 v-html="subTitle" />
            </template>
            <template v-else>
                <header-signature :text="subTitle" />
            </template>
        </div>
    </div>
</template>

<script>
import RecoMobile from "./RecoMobile.vue";
import HeaderSignature from "../../../../common/components/vue/HeaderSignature.vue";

export default {
    components: {HeaderSignature, RecoMobile},
    props: {
        mobiles: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: false,
            default: null
        },
        shop: {
            type: String,
            required: true
        },
        advantageMessages: {
            type: Object,
            required: true
        },
        linkLabel: {
            type: String,
            required: false,
            default: null
        },
        linkUrl: {
            type: String,
            required: false,
            default: null
        },
        dataPdbZid: {
            type: String,
            required: true
        },
        fundingDetailsDto: {
            type: Object,
            required: true
        }
    },
    mounted: function () {
        const swiper = new Swiper(".reco-mobiles-swiper-container", {
            slidesPerView: "auto",
            spaceBetween: 30,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initialSlide: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        window.addEventListener("resize", () => {
            this.updateLayout();
        });
        this.updateLayout();

    },
    updated() {
        this.$nextTick(function () {
            const swiperContainer = document.querySelector('.reco-mobiles-swiper-container');
            if (swiperContainer !== null) {
                const swiper = swiperContainer.swiper;
                swiper.update();
            }
            this.updateLayout();
        })
    },
    methods: {
        updateLayout() {
            this.alignCardItemsVertically(".swiper-1row");
            this.alignCardItemsVertically(".grid-4col");
        },
        alignCardItemsVertically(baseSelector) {
            this.alignItemsVertically(baseSelector + " " + ".device-name-wrapper");
            this.alignItemsVertically(baseSelector + " "  +".infos-price");
            this.alignItemsVertically(baseSelector + " " + ".info-advantage");
        },
        getMaximumHeight(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            const heights = elts.map( (elt, index) => {
                const h = $(elt).height();
                return h;
            });
            return Math.max(...heights);
        },
        alignItemsVertically(selector) {
            const elts = Array.from(document.querySelectorAll(selector));
            elts.forEach( elt => elt.style.removeProperty("height"));
            const maxHeight = this.getMaximumHeight(selector);
            if (maxHeight === 0) {
                return;
            }
            elts.forEach( elt => $(elt).height(maxHeight));
        },
        numberOfRows(col) {
            if (this.mobiles.length === 0) {
                return 1;
            }
            return Math.trunc((this.mobiles.length - 1) / col) + 1;
        },
        mobileAt(x, y, col) {
            return this.mobiles[(x - 1) + (y - 1) * col];
        },
        handleFundingDetailsClick(versionSeoId) {
            this.$emit('fundingDetailsClick', versionSeoId);
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.ob1-carrousel .ob1-carrousel-controls, .ob1-carrousel .swiper-button-next, .ob1-carrousel .swiper-button-prev {
    top: 42%;
    background: black;
}

.swiper-1row > div {
    overflow: hidden;
}

.swiper-slide {
    width: px-to-rem(238);
    @media(min-width: #{map-get($grid-breakpoints, sm)}) {
        width: px-to-rem(280);
    }
}
</style>
